import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";

type DeleteTemplateDialog = {
    open: boolean;
    handleClose: () => void;
    handleDelete: () => void;
};

function DeleteTemplateDialog({
    handleClose,
    handleDelete,
    open,
}: DeleteTemplateDialog) {
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Deletar documento</DialogTitle>
            <DialogContent>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 2 }}
                >
                    Você tem certeza que deseja excluir o documento?
                    <br />
                    Essa ação é irreverssível
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button
                    onClick={handleDelete}
                    variant="contained"
                    color="error"
                >
                    Deletar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DeleteTemplateDialog;
